/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthorizationRequestRouteImport } from './routes/authorization-request'
import { Route as IndexRouteImport } from './routes/index'

const AuthorizationRequestRoute = AuthorizationRequestRouteImport.update({
  id: '/authorization-request',
  path: '/authorization-request',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authorization-request': typeof AuthorizationRequestRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authorization-request': typeof AuthorizationRequestRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/authorization-request': typeof AuthorizationRequestRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/authorization-request'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/authorization-request'
  id: '__root__' | '/' | '/authorization-request'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthorizationRequestRoute: typeof AuthorizationRequestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/authorization-request': {
      id: '/authorization-request'
      path: '/authorization-request'
      fullPath: '/authorization-request'
      preLoaderRoute: typeof AuthorizationRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthorizationRequestRoute: AuthorizationRequestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
